import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChevronLeftWhiteFilled from 'assets/chevron_left_white_filled.svg?react';
import crown_img from 'assets/crown.svg';
import mask from 'assets/mask.svg';
import BuyTokenButton from 'components/BuyTokenButton';
import CommonHelper from 'helpers/CommonHelper';
import { useMappedState } from 'redux-react-hook';
import styled from 'styled-components';
import { isBlank } from 'utils/storeUtils';

const MobileDialogTitle = (props) => {
  const {
    coverUrl,
    publicName,
    characterNames,
    onSignInModalOpen,
    onSignUpModalOpen,
    onEmailConfirmationModalOpen,
    onSubscriptionModalOpen
  } = props;

  const { currentUser, isSignedIn, hasSubscription } = useMappedState(
    state => {
      const currentUserId = state.users.currentUserId;
      const currentUser = state.users.usersMap.get(currentUserId);
      const hasSubscription = !!currentUser?.hasSubscription;
      const isSignedIn = !isBlank(currentUserId);
      return {
        currentUser: currentUser,
        hasSubscription: hasSubscription,
        isSignedIn: isSignedIn
      };
    });

  const navigate = useNavigate();

  const onPremiumClick = () => {
    if (!isSignedIn) {
      onSignUpModalOpen();
      return;
    }

    if (!currentUser?.emailVerified) {
      onEmailConfirmationModalOpen();
      return;
    }

    onSubscriptionModalOpen({
      isOpen: true,
      renderedForReason: 'mobile_header_premium_click'
    });
  };

  return (
    <Wrapper>
      <BackButton onClick={() => navigate(-1)}>
        <ChevronLeftWhiteFilled />
      </BackButton>
      <TopImage
        src={coverUrl ? CommonHelper.getFilesCdnUrl(coverUrl) : mask}
        alt={'cover'}
        style={{ padding: coverUrl ? '' : '8px' }}
      />

      <TitleContainer>
        <ModalHeading>{publicName}</ModalHeading>
        {characterNames && <CharacterNames>{characterNames}</CharacterNames>}
      </TitleContainer>

      {!hasSubscription && isSignedIn && (
        <PremiumButton
          className={'md:mr-4'}
          onClick={onPremiumClick}
        >
          <img className={'mr-2'} style={{ height: '24px' }} src={crown_img} />
          Premium
        </PremiumButton>
      )}

      {hasSubscription && (
        <BuyTokenButton isMobile onPremiumClick={onPremiumClick} />
      )}

      {!isSignedIn && (
        <OrangeButton onClick={onSignInModalOpen}>
          Sign in
        </OrangeButton>
      )}
    </Wrapper>
  );
};

export default MobileDialogTitle;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  flex: 1;
  min-width: 0;
  margin-left: 12px;
  margin-right: 8px;
`;

const ModalHeading = styled.p`
  margin: 0;
  font-size: 16px;
  font-family: Raleway;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #FFFFFF;
`;

const CharacterNames = styled.p`
  margin: 0;
  color: #A9A9A9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

const Wrapper = styled.div`
  margin-top: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  height: 68px;
  align-items: center;
  width: 100%;
  overflow: hidden;
  padding: 16px 8px;
`;

const TopImage = styled.img`
  height: 36px;
  width: 36px;
  object-fit: cover;
  border-radius: 50%;
`;

const BackButton = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 8px 0px 4px;

  svg {
    width: 18px;
    height: 18px;
    color: white;
  }
`;

const PremiumButton = styled.div`
  cursor: pointer;
  color: white;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  height: 48px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 1000px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);

  @media (max-width: 768px) {
    height: 36px;
    padding-left: 15px;
    padding-right: 15px;
    font-size: 16px;
  }
`;

const OrangeButton = styled.div`
  cursor: pointer;
  background: rgba(255, 126, 85, 1);
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 36px;
  padding: 8px 16px;
  gap: 10px;
  border-radius: 1000px;
  font-family: Nunito Sans;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
`;

